import React from "react";
import { PageList } from "../components/pageList";
import { useTableSchema } from "../hooks/useTableSchema";
import { useFormSchema } from "../hooks/useFormSchema";

const UserGroup = ({ title = "User Group" }) => {
  const [getTableSchema] = useTableSchema();
  const [getFormSchema] = useFormSchema();

  return (
    <PageList
      title={title}
      apiEntity={"userGroup"}
      tableSchema={getTableSchema("userGroup")}
      formSchema={getFormSchema("userGroup")}
      showImport={false}
      searchByTextField={true}
    />
  );
};

export default UserGroup;
